"use client";
import React from "react";
import Section from "./Section";
import { H4 } from "@/components-shared/headers";
import { format } from "date-fns";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components-shared/ui/button";

const Host = ({
  hostname,
  createdAt,
  propsNum,
  ownerId,
}: {
  hostname: string;
  createdAt: string;
  propsNum: number;
    ownerId?: string;
}) => {
  const t = useTranslations();

  return (
    <Section className="border rounded-2xl p-5 sm:mb-10 mb-5">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          {ownerId ? (
            <Link href={`/owner/${ownerId}`}>
              <H4 className="text-green-main hover:text-green-700 transition-colors cursor-pointer">
                {t("host.hostedBy")}: {hostname}
              </H4>
            </Link>
          ) : (
              <H4 className="text-green-main">
                {t("host.hostedBy")}: {hostname}
              </H4>
          )}
        </div>
        {ownerId && (
          <Link href={`/owner/${ownerId}`}>
            <Button variant="outline" size="sm">
              {t("host.details")}
            </Button>
          </Link>
        )}
      </div>
      <div className="*:flex *:justify-between *:items-center space-y-3">
        <Row
          name={t("host.joinDate")}
          value={
            createdAt ? format(new Date(createdAt), "dd-MM-yyyy") : "-----"
          }
        />
        <Row
          name={t("host.unitCount")}
          value={`${propsNum} ${
            propsNum === 1 ? t("host.unit") : t("host.units")
          }`.replace(/1$/, t("host.singleUnit"))}
        />
      </div>
    </Section>
  );
};

export default Host;

type Props = {
  name: string;
  value: string;
};

const Row = ({ name, value }: Props) => {
  return (
    <p>
      <span className="max-sm:text-sm">{name}</span>
      <span className="max-sm:text-sm">{value}</span>
    </p>
  );
};
